import { useMemo } from 'react';
import { useTranslations } from '@/i18n/use-translations';
import { useFlowStore } from '@/state/stores/use-flow-store';
import { useFlowControlMediaExpandStore } from '@/state/stores/use-flow-control-media-expand-store';
import { useFlowControlPlayingSegmentExpandId } from '@/components/flows/detail/slot-list/use-flow-control-playing-segment-expand-id';
import {
  resolveFlowControlOverlayActiveExpandId,
  resolveFlowControlOverlayHeader,
} from '@/helpers/flow-control-overlay-header.helper';
import type { FlowSlotDto } from '@/types/dtos/flows/response/flow.dto';

/** Overlay top-bar title/subtitle for the browsed or playing control segment. */
export function useFlowControlOverlayHeader(fallbackSlot?: FlowSlotDto) {
  const t = useTranslations();
  const flow = useFlowStore((s) => s.flow);
  const flowPlan = useFlowStore((s) => s.flowPlan);
  const expandId = useFlowControlMediaExpandStore((s) => s.expandId);
  const expandSource = useFlowControlMediaExpandStore((s) => s.expandSource);
  const playingExpandId = useFlowControlPlayingSegmentExpandId();
  const controlSubtitle = t('flows.detail.editDetails.controlTitle');

  const activeExpandId = resolveFlowControlOverlayActiveExpandId(
    expandId,
    playingExpandId,
    fallbackSlot?.id,
    expandSource,
  );

  return useMemo(
    () =>
      resolveFlowControlOverlayHeader({
        activeExpandId,
        flow,
        flowPlan,
        fallbackSlot,
        t,
        controlSubtitle,
      }),
    [activeExpandId, controlSubtitle, fallbackSlot, flow, flowPlan, t],
  );
}
